import { render, staticRenderFns } from "./SharePayLink.vue?vue&type=template&id=67623e0a&scoped=true"
import script from "./SharePayLink.vue?vue&type=script&lang=js"
export * from "./SharePayLink.vue?vue&type=script&lang=js"
import style0 from "./SharePayLink.vue?vue&type=style&index=0&id=67623e0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67623e0a",
  null
  
)

export default component.exports